module.exports = __webpack_public_path__ + "img/sceneCover.64ec6b35.jpg";